import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  IDENTIALERT_SUBSCRIPTION,
  IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG,
  IDENTIBASE_PLUS_SUBSCRIPTION,
  IDENTIBASE_PLUS_SUBSCRIPTION_ADESTRA_TAG,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ADESTRA_TAG,
  IDENTIFIND_SUBSCRIPTION,
  IDENTIFIND_SUBSCRIPTION_ADESTRA_TAG,
  PITPAT_SUBSCRIPTION,
  PITPAT_SUBSCRIPTION_ADESTRA_TAG,
  TRANSFER_OF_KEEPERSHIP_BREEDER,
  TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ADESTRA_TAG,
  UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG,
} from 'src/app/constants/app.constants';
import { Pet } from 'src/app/interfaces/pet';

@Component({
  selector: 'app-identibase-sub-appreciation',
  templateUrl: './identibase-sub-appreciation.component.html',
})
export class IdentibaseSubAppreciationComponent implements OnInit, AfterViewInit {
  public identiSubAdestraTag: string;
  public navRoute: string;
  public isAdestraTagReady: boolean = false;
  public hasEligiblePets: boolean;
  private chipNumber: string | undefined;
  private vetCode: string | undefined;

  constructor(private _router: Router, private _activatedRoute: ActivatedRoute) {
    const eligiblePets = this._activatedRoute.snapshot.data.eligiblePets as Pet[];
    this.hasEligiblePets = eligiblePets?.length > 0;
  }

  ngOnInit() {
    const queryParams = this._activatedRoute.snapshot.queryParams;
    if (queryParams && queryParams.subscriptionType) {
      this.setSubAdestraTagAndNavRoute(queryParams);
    } else {
      this.identiSubAdestraTag = UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG;
      this.navRoute = '/dashboard';
    }

    this.isAdestraTagReady = true;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      switch (this.navRoute) {
        case '/dashboard':
          if (this.identiSubAdestraTag === TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG) {
            this._router.navigate([this.navRoute], { queryParams: { tokExplore: 'open' } });
            break;
          }

          if (this.hasEligiblePets) {
            this._router.navigate([this.navRoute]);
          }

          this._router.navigate([this.navRoute], { queryParams: { followUs: 'open' } });
          break;
        case '/rehome-pet':
          this._router.navigate([this.navRoute], {
            queryParams: { chipNumber: this.chipNumber, vetCode: this.vetCode },
          });
          break;
        default:
          this._router.navigate([this.navRoute]);
      }
    }, 3000);
  }

  private setSubAdestraTagAndNavRoute(queryParams: Params) {
    const subscriptionType = queryParams.subscriptionType;
    const petId = queryParams.petId;
    const chipNumber = queryParams.chipNumber;
    const vetCode = queryParams.vetCode;

    switch (subscriptionType) {
      case IDENTIBASE_PLUS_SUBSCRIPTION:
        this.identiSubAdestraTag = IDENTIBASE_PLUS_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS:
        this.identiSubAdestraTag = IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ADESTRA_TAG;
        this.navRoute = '/account/user-details';
        break;
      case IDENTIALERT_SUBSCRIPTION:
        this.identiSubAdestraTag = IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case IDENTIFIND_SUBSCRIPTION:
        this.identiSubAdestraTag = IDENTIFIND_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case PITPAT_SUBSCRIPTION:
        this.identiSubAdestraTag = PITPAT_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case TRANSFER_OF_KEEPERSHIP_BREEDER:
        this.identiSubAdestraTag = TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT:
        this.identiSubAdestraTag = TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ADESTRA_TAG;

        if (chipNumber && vetCode) {
          this.navRoute = `/rehome-pet`;
          this.chipNumber = chipNumber;
          this.vetCode = vetCode;
        } else {
          this.navRoute = '/dashboard';
        }
        break;
      default:
        this.identiSubAdestraTag = UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
    }
  }
}
